/** Brief 12, the shell and the shared components. */
export const uzB12Foundation = {
  "nav.short.home": "Bosh",
  "nav.short.tasks": "Vazifa",
  "nav.short.conversations": "Suhbat",
  "nav.short.deals": "Bitim",
  "nav.short.bronlar": "Bron",
  "nav.short.clients": "Mijoz",
  "nav.short.finance": "Moliya",
  "nav.short.reports": "Hisobot",
  "nav.short.menu": "Menyu",
  "nav.aria.main": "Asosiy menyu",
  "nav.aria.tabs": "Asosiy bo'limlar",
  "shell.collapseShort": "Yig'ish",
  "shell.create": "Yaratish",
  "shell.create.task": "Vazifa",
  "shell.drawer": "Menyu",
  "shell.agency.switch": "Agentlik va filial",
  "shell.agency.current": "Joriy agentlik",
  "shell.searchHint": "Mijoz, bitim, bron raqami, telefon",
  "shell.palette.searchPlaceholder": "Mijoz, bitim, bron raqami yoki telefon",
  "shell.palette.kind.section": "Bo'lim",
  "shell.palette.kind.client": "Mijoz",
  "shell.palette.kind.deal": "Bitim",
  "shell.palette.kind.booking": "Bron",
  "shell.palette.kind.profile": "Profil",
  "shell.palette.searching": "Qidirilmoqda",
  "shell.palette.deal": "Bitim №{id} · {name}",
  "shell.palette.booking": "Bron {ref} · {name}",
  "shell.menu.myStatus": "Mening holatim",
  "shell.menu.weekLine": "Bu hafta: {count} sotuv",
  "shell.menu.myReport": "Hisobotim",
  "shell.menu.statusNote": "«Ishda» holatida yangi murojaatlar sizga yuboriladi.",
  "shell.menu.darkSidebar": "Qorong'i menyu",
  "shell.notifications.title": "Bildirishnomalar",
  "shell.notifications.read": "O'qildi",
  "shell.notifications.setup": "Sozlash",
  "shell.notifications.group.clients": "Mijozlar",
  "shell.notifications.group.operators": "Operator xabarlari",
  "shell.notifications.group.tasks": "Vazifalar",
  "shell.notifications.group.system": "Tizim",

  "ui.close": "Yopish",
  "ui.cancel": "Bekor qilish",
  "ui.undo": "Bekor qilish",
  "ui.retry": "Qayta urinish",
  "ui.denied.title": "Ruxsat yo'q",
  "ui.denied.body": "{role} roli bu bo'limni ko'rmaydi. Kerak bo'lsa, agentlik egasiga yozing.",
  "ui.denied.home": "Bosh sahifaga",
  "ui.error.title": "Yuklab bo'lmadi",
  "ui.error.body": "Server javob bermadi. Kiritgan ma'lumotlaringiz saqlangan, sahifani qayta yuklash xavfsiz.",
  "ui.ai.name": "Kapitan AI",
  "ui.ai.on": "AI yoqiq",
  "ui.ai.off": "AI o'chiq",
  "ui.owner": "Mas'ul:",
  "ui.note.hidden": "mijoz ko'rmaydi",
  "ui.note.aiSees": "AI ko'radi",
  "ui.note.meta": "Ichki izoh · {time}",
  "ui.draft.title": "Qoralama",
  "ui.draft.waiting": "Tasdiq kutmoqda",
  "ui.draft.sources": "Manbalar ({count}) · {names}",
  "ui.draft.edit": "Tahrirlash",
  "ui.draft.reject": "Rad etish",
  "ui.draft.send": "Yuborish",
  "ui.seat.flight.ok": "Reysda joy bor",
  "ui.seat.flight.few": "Reysda joy kam",
  "ui.seat.flight.few.count": "Reysda joy kam ({count})",
  "ui.seat.flight.none": "Reysda joy yo'q",
  "ui.seat.hotel.ok": "Mehmonxonada joy bor",
  "ui.seat.hotel.few": "Mehmonxonada joy kam",
  "ui.seat.hotel.few.count": "Mehmonxonada joy kam ({count})",
  "ui.seat.stopSale": "Stop sale",
  "ui.operators.asking": "Operatorlar so'ralmoqda…",
  "ui.operators.answered": "{total} operatordan {done} tasi javob berdi",
  "ui.provider.error": "xato",
  "ui.close.title": "Suhbat qanday yakunlandi?",
  "ui.close.reason": "Sabab",
  "ui.close.submit": "Yopish",
  "ui.task.title": "Vazifa · {name}",
  "ui.task.type": "Turi",
  "ui.task.text": "Nima qilish kerak",
  "ui.task.date": "Sana",
  "ui.task.time": "Soat",
  "ui.task.note": "Izoh",
  "ui.task.notePlaceholder": "Masalan, kechqurun qo'ng'iroq qilishni so'radi",
  "ui.task.add": "Qo'shish",
  "ui.route.step": "{step}/{total} · {name}",
  "ui.kpi.previous": "Oldingi davr",
  "ui.loading.page": "Ma'lumot olinmoqda",
} as const;
